import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup } from "components";
import { maxValue100 } from "validators/validation";

type NewRentalSectionProps = {
	sectionName: string;
	isLoading?: boolean;
	defaultValues: any;
	placeholder: string;
	validator: any;
	normalize: any;
	normalizeOnBlur: any;
	errors: any;
};

const NewRentalSection = ({
	sectionName,
	isLoading = false,
	defaultValues,
	placeholder,
	validator,
	normalize,
	normalizeOnBlur,
	errors,
}: NewRentalSectionProps) => {
	const { register } = useFormContext();
	return (
		<>
			<Row className="form-group">
				<Col md={5}>
					<HookFormInputGroup
						name={`${sectionName}.monthRentalPrice`}
						register={register}
						label="Rental Price (per month), $"
						defaultValue={defaultValues?.monthRentalPrice}
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder={placeholder}
						showRequiredMark
						validator={{ ...validator }}
						normalize={normalize}
						normalizeOnBlur={normalizeOnBlur}
						errors={errors}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<HookFormInputGroup
						name={`${sectionName}.equipmentInsurance`}
						register={register}
						label="Equipment Insurance, $"
						defaultValue={defaultValues?.equipmentInsurance}
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder={placeholder}
						showRequiredMark
						validator={{ ...validator }}
						normalize={normalize}
						normalizeOnBlur={normalizeOnBlur}
						errors={errors}
					/>
				</Col>
			</Row>

			<Row className="form-group">
				<Col md={5}>
					<HookFormInputGroup
						name={`${sectionName}.shippingAndHandling`}
						register={register}
						label="Shipping and Handling (one time), $"
						defaultValue={defaultValues?.shippingAndHandling}
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder={placeholder}
						showRequiredMark
						validator={{ ...validator }}
						normalize={normalize}
						normalizeOnBlur={normalizeOnBlur}
						errors={errors}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<HookFormInputGroup
						name={`${sectionName}.estimatedTax`}
						register={register}
						label="Estimated Tax, $"
						defaultValue={defaultValues?.estimatedTax}
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder={placeholder}
						showRequiredMark
						validator={{ ...validator }}
						normalize={normalize}
						normalizeOnBlur={normalizeOnBlur}
						errors={errors}
					/>
				</Col>
			</Row>

			<Row className="form-group">
				<Col md={5}>
					<HookFormInputGroup
						name={`${sectionName}.stateTax`}
						register={register}
						label="State tax, %"
						defaultValue={defaultValues?.stateTax}
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						autoComplete="off"
						placeholder={placeholder}
						showRequiredMark
						validator={{ ...validator, maxValue100 }}
						normalize={normalize}
						normalizeOnBlur={normalizeOnBlur}
						errors={errors}
					/>
				</Col>
			</Row>
		</>
	);
};

export default NewRentalSection;
